// extracted by mini-css-extract-plugin
export default {"marker":"style_marker__rJfVK"};